import React from "react";

const ParamAreas = ({ areas }) => {
  const { features } = areas || [];
  return <div>{features.map(f => f.properties.description).join(`, `)}</div>;
};

export default ParamAreas;
